import React, { useState, useCallback, useEffect } from "react";
import {AppMenu} from "./AppMenu";


interface CaseStudiesProps {}

interface CaseStudiesState {}

const CaseStudies: React.FC<CaseStudiesProps> = ({}) => {           
    const [pageState, setPageState] = useState<CaseStudiesState>(() => {});

    return(
        <>
            <div style={{width: "100%", textAlign: "left"}}>
                            <AppMenu/>
                        </div>
                        <div key={'PS7'} style={{ 
                        flex: '1 1 calc(100% - 40px)',
                        minWidth: '250px',
                        height: '570px',
                        background: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        overflow: 'hidden'
                      }}>
                        <div style={{ 
                          padding: '15px', 
                          borderBottom: '0px solid #e1e1e1',
                          background: '#ffffff',
                          fontWeight: 600,
                          color: '#323130'
                        }}>
                          Locations
                        </div>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                           <div className="card-full-grey">         
                            <ul className="card-full-list-grey">                  
                              <li key="esdxg-cs1">
                                  keep watching this space for more updates from customers.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
        </>
    );
}

export default CaseStudies; 
